// extracted by mini-css-extract-plugin
export default {"viewer3dContainer":"Viewer3d__viewer3dContainer___TpBhU","babylonJsCanvas":"Viewer3d__babylonJsCanvas___Djn98"};